// import { googleMapsRequest } from "@/utils";
import { googleMapsRequest } from "@/utils/googleMap.api.helper.js";

export const googleMapService = {
    searchPlaces,
};

export async function searchPlaces(data) {
    const headers = {
        "Content-Type": "application/json",
        "X-Goog-FieldMask": "places.id,places.displayName.text,places.formattedAddress,places.location,places.addressComponents",
    };
    const requestBody = {
        textQuery: data['searchQuery'],
        languageCode: "en",
        regionCode: "MY",
        locationBias: {
            rectangle: {
                low: { latitude: data['latitude'] == null ? 0.857 : data['latitude'] , longitude: data['longitude'] == null ?  98.0 : data['longitude']  }, // Southwest Malaysia
                high: { latitude: data['borderLatitude'] == null ? 7.35 : data['borderLatitude'], longitude: data['borderLongitude'] == null ? 119.0 : data['borderLongitude'] } // Northeast Malaysia
            }
        }
    };
    const response = await googleMapsRequest("places:searchText", requestBody, headers)
    return response;
}

